import { ConfDefnComponentType } from './confdefnComponents';
/**
 * @deprecated
 *
 * Please use ConfDefnComponentType instead.
 *
 * This is no longer the preferred type values for configuring worklist components.
 * It is here strictly for backward compatibility.
 * */
export var LegacyWorklistComponentType;
(function (LegacyWorklistComponentType) {
    LegacyWorklistComponentType["visualize"] = "visualize";
    LegacyWorklistComponentType["pricing"] = "pricing";
    LegacyWorklistComponentType["flowsheet"] = "flowsheet";
    LegacyWorklistComponentType["styleEdit"] = "styleEdit";
    LegacyWorklistComponentType["collectionView"] = "CollectionView";
    LegacyWorklistComponentType["gridView"] = "GridView";
    LegacyWorklistComponentType["flowType"] = "FlowType";
    LegacyWorklistComponentType["summaryView"] = "SummaryView";
    LegacyWorklistComponentType["nestedView"] = "NestedView";
    LegacyWorklistComponentType["nestedStyleOverTime"] = "NestedStyleOvertime";
    LegacyWorklistComponentType["nestedOvertime"] = "NestedOvertime";
})(LegacyWorklistComponentType || (LegacyWorklistComponentType = {}));
export function isWorklistTabWithComponentProps(tab) {
    return (tab.componentType === ConfDefnComponentType.collectionView ||
        tab.componentType === ConfDefnComponentType.gridView ||
        tab.componentType === ConfDefnComponentType.flowType ||
        tab.componentType === ConfDefnComponentType.summaryView ||
        tab.componentType === ConfDefnComponentType.nestedView ||
        tab.componentType === ConfDefnComponentType.enhancedOvertime ||
        tab.componentType === ConfDefnComponentType.quickTrends ||
        tab.componentType === ConfDefnComponentType.configurableGrid ||
        tab.componentType === ConfDefnComponentType.receiptGrid ||
        tab.componentType === ConfDefnComponentType.flowSheet ||
        tab.componentType === ConfDefnComponentType.nestedStyleOverTime ||
        tab.componentType === ConfDefnComponentType.nestedOvertime ||
        tab.componentType === ConfDefnComponentType.geoTrends ||
        tab.componentType === ConfDefnComponentType.categorySummary ||
        tab.componentType === ConfDefnComponentType.nestedAttribute ||
        tab.componentType === ConfDefnComponentType.productMix);
}
